import { render, staticRenderFns } from "./BankAcctList.vue?vue&type=template&id=e20fdc16&"
import script from "./BankAcctList.vue?vue&type=script&lang=js&"
export * from "./BankAcctList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports